import axios from "axios";
import { getApiBaseUrl } from "./getData";

/**
 * Живой прогресс ИИ-агента.
 *
 * Основной запрос (chat) идёт обычным POST и отвечает только в конце. Пока он
 * выполняется, панель опрашивает этот адрес и показывает, что агент делает
 * сейчас: строит план, ищет пациента, читает документы, формулирует ответ.
 *
 * Сервер отдаёт только типовые подписи и имена инструментов — без
 * персональных данных и без содержимого ответа.
 */
export async function fetchAiProgress(requestId, timeout = 5000) {
    const id = String(requestId || "").trim();
    if (!id) return null;

    try {
        const response = await axios.get(`${getApiBaseUrl()}progress`, {
            params: { id },
            withCredentials: true,
            timeout,
            validateStatus: () => true,
        });
        if (response.status >= 400) return null;
        const payload = response?.data;
        return payload?.request?.result ?? null;
    } catch (err) {
        return null;
    }
}

/** Список файлов журнала ИИ на сервере (диагностика). */
export async function fetchAiJournalStats() {
    try {
        const response = await axios.get(`${getApiBaseUrl()}ai-journal`, {
            withCredentials: true,
            timeout: 10000,
            validateStatus: () => true,
        });
        return response?.data?.request?.result ?? null;
    } catch (err) {
        return null;
    }
}

export default fetchAiProgress;
